/** Rutas donde el selector de grupo no aplica (scope de proyecto). */
export const PROJECT_SCOPED_PATH_KEYWORDS = [
	'negocios/web',
	'/informes/api',
	'/home',
	'/configurar',
];

export const isProjectScopedPath = (pathname: string): boolean =>
	PROJECT_SCOPED_PATH_KEYWORDS.some((word) => pathname.includes(word));
